import React from 'react';
import { LegalDocPage } from './LegalDocPage';

export const TermsPage: React.FC = () => {
  return (
    <LegalDocPage
      docId="terms"
      title="Terms of Service"
      updatedAt="January 13, 2026"
    />
  );
};
